"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeldCoverNoteDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_held_cover_note_entity_1 = require("./opportunity-held-cover-note.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let HeldCoverNoteDocumentMap = class HeldCoverNoteDocumentMap {
};
exports.HeldCoverNoteDocumentMap = HeldCoverNoteDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "held_cover_note_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentMap.prototype, "heldCoverNoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], HeldCoverNoteDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_held_cover_note_entity_1.OpportunityHeldCoverNote, (heldCoverNote) => heldCoverNote.documents, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "held_cover_note_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _a : Object)
], HeldCoverNoteDocumentMap.prototype, "heldCoverNote", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _b : Object)
], HeldCoverNoteDocumentMap.prototype, "document", void 0);
exports.HeldCoverNoteDocumentMap = HeldCoverNoteDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "held_cover_note_document_map" })
], HeldCoverNoteDocumentMap);
